'use strict';

// The babel polyfills are required for older browsers like IE9
import 'babel/polyfill';

// This has to be done before loading wr360
import { improveWebrotate360 } from './improve-webrotate360';
improveWebrotate360();

var $ = require('jquery');
require('modernizr');

var Application = require('./Application');


$(function() {
    new Application.Application();
});



/** WEBPACK FOOTER **
 ** ./js/main.js
 **/